import React, {useEffect, useState} from "react";
import {bindActionCreators} from "redux";
import customerActionsImp from "../../../Actions/customerActions";
import {useDispatch, useSelector} from "react-redux";
import {VossEditForm} from "../../../Utils/customerFormUtils";
import formActionsImp from "../../../Actions/formActions";
import TargetGroupActionsImp from "../../../Actions/Voss/targetGroupActions";
import targetGroupHelpers from "../../../Utils/targetGroups";
import {targetGroupConfigurations} from "../../../Constants/VOSS/targetGroups";
import * as formValidationRules from "../../../Constants/formValidationRules";
import useCustomerExpiryDate from "../../../Hooks/Customer/useCustomerExpiryDate";
import {CustomerForm} from "./CustomerForm";

export const EditVossCustomerForm = ({}) => {
    const dispatch = useDispatch();
    const customer = useSelector((state) => state.CustomerReducer.customer);
    const customerActions = bindActionCreators(customerActionsImp, dispatch);
    const form = useSelector((state) => state.FormReducer.forms.customerFormData);
    const dropdownLists = useSelector((state) => state.CommonReducer.dropdownlists);
    const targetGroupsActions = bindActionCreators(TargetGroupActionsImp, dispatch);
    const targetGroups = useSelector((state) => state.TargetGroupsReducer.targetGroups);
    const formActions = bindActionCreators(formActionsImp, dispatch);
    const [validationRules, setValidationRules] = useState(formValidationRules.VossCustomerForm);
    const { showExpiryDate } = useCustomerExpiryDate(form);

    const [initialLockState, setInitialLockState] = useState({
        isAddressLocked: false,
        isInvoiceEmailLocked: false
    });

    useEffect(() => {
        if (!form) {
            customerActions.getSelectedCustomerForEdit(customer.vossCustomer.id, formValidationRules.VossCustomerForm);
        }
        if (!targetGroups) {
            targetGroupsActions.getTargetGroups();
        }

    }, []);

    useEffect(() => {
        if (form) {
            setInitialLockState({
                isAddressLocked: form.data.isAddressLocked ?? false,
                isInvoiceEmailLocked: form.data.isInvoiceEmailLocked ?? false
            });
        }
    }, [form?.id]);

    function isCustomerAddressRequired() {
        return targetGroupHelpers.hasConfig(targetGroups, form?.data?.targetGroups, targetGroupConfigurations.customerAddressRequired);
    }
    function isContactPersonRequired() {
        return targetGroupHelpers.hasConfig(targetGroups, form?.data?.targetGroups, targetGroupConfigurations.contactPersonRequired);
    }
    function isOrganizationNumberRequired() {
        return targetGroupHelpers.hasConfig(targetGroups, form?.data?.targetGroups, targetGroupConfigurations.organizationNumberRequired);
    }

    function updateFormValidationRules() {
        let rules = [
            { inputId: 'name', rule: 'required', message: 'Company name is required' },
        ]

        if (isOrganizationNumberRequired()) {
            rules = [
                ...rules,
                ...formValidationRules.CustomerSearchForm
            ];
        }

        if (isContactPersonRequired()) {
            rules = [
                ...rules,
                ...formValidationRules.CustomerContactPersonForm
            ];
        }
        if (isCustomerAddressRequired()) {
            rules = [
                ...rules,
                ...formValidationRules.VossCustomerAddressForm
            ];
        }

        if (form?.data?.testCustomer) {
            rules = [
                ...rules,
                ...formValidationRules.VossTestCustomerForm
            ];
        }

        setValidationRules(rules);
    }

    useEffect(() => {
        if (!form) return;

        formActions.updateFormValidationRules(form.id, validationRules);
    }, [validationRules]);


    useEffect(() => {
        updateFormValidationRules();
    }, [form?.data?.targetGroups, targetGroups]);
    
    if (!form) {
        return null;
    }
    
    const params = {
        testCustomer: form?.data?.testCustomer,
        showExpiryDate: showExpiryDate,
        isAddressLocked: initialLockState.isAddressLocked,
        isInvoiceEmailLocked: initialLockState.isInvoiceEmailLocked
    };
    
    return <CustomerForm
        columns={VossEditForm(dropdownLists)}
        form={form}
        fieldParams={params}
    />
}